import { CarrierWebviewHeader } from '../CarrierWebviewHeader';
import { OnboardingPacketsTable } from '../../onboarding-packets/OnboardingPacketsTable';
import { OnboardingPacketStatus } from 'shared/modules/onboarding-packets/data/OnboardingPacketDTO';

export interface OnboardingPacketsWebViewPageProps {
  status?: OnboardingPacketStatus;
}

export function OnboardingPacketsWebViewPage({
  status,
}: OnboardingPacketsWebViewPageProps) {
  return (
    <CarrierWebviewHeader>
      <OnboardingPacketsTable status={status} />
    </CarrierWebviewHeader>
  );
}
